import { Button } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  ${Button.Styled.Label} {
    color: var(--text-primary);
  }
`;
